import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ProcessSection from '../../components/feature/ProcessSection';
import PhilosophySection from '../../components/feature/PhilosophySection';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import ContactSection from '../../components/feature/ContactSection';
import ServicesSection from '../../components/feature/ServicesSection';
import MidPageCTA from '../../components/feature/MidPageCTA';
import AboutStorySection from './components/AboutStorySection';

const ABOUT_FAQS = [
  {
    q: 'Who is Lisa Merkle and what is her design background?',
    a: 'Lisa Merkle is a formally trained interior designer based in Beverly Hills. She received her design education at UCLA and gained experience at several of Los Angeles\'s most prestigious celebrity design firms. Her work blends classical European design — French, Italian, and Spanish — with California sophistication and enduring modern elegance.',
  },
  {
    q: 'Where has Lisa Merkle Design been published or featured?',
    a: 'Lisa Merkle Design has been featured in Elle Décor and Architectural Digest — two of the most prestigious design publications in the world — along with numerous other lifestyle publications. This editorial recognition reflects the studio\'s position at the very top tier of luxury residential interior design.',
  },
  {
    q: 'What type of clients does Lisa Merkle Design work with?',
    a: 'Lisa Merkle Design works with an impressive and diverse client roster — household names, business leaders, high-net-worth families, and property investors. We partner with clients who value design excellence, craftsmanship, and a thoughtful approach to protecting and enhancing long-term property value.',
  },
  {
    q: 'How does Lisa Merkle approach a new design project?',
    a: 'Every project begins with an in-depth discovery consultation to understand the client\'s vision, lifestyle, and investment goals. Lisa then develops a comprehensive design concept, curates materials and vendors, and leads the project from concept through final installation with personal attention at every stage.',
  },
  {
    q: 'Does Lisa Merkle Design take projects outside Beverly Hills?',
    a: 'Yes — while rooted in Beverly Hills, Lisa Merkle Design leads projects for clients nationwide. Our studio has directed complex residential and commercial projects in luxury markets throughout California and beyond, serving discerning clients wherever extraordinary design is needed.',
  },
];

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection
          badge="About Lisa Merkle Design"
          title="Beverly Hills Interior Designer"
          titleItalic="& Luxury Living Expert"
          subtitle="UCLA trained. Celebrity firm experience. Published in Elle Décor & Architectural Digest."
          description="A design studio where classical European elegance meets California sophistication — led by a designer who has built a career at the absolute top of luxury residential design."
          bgImage="https://lisamerkledesign.com/wp-content/uploads/2022/12/247939327_469089814544164_5504384596549462822_n.jpg"
          ctaText="Schedule a Consultation"
          ctaLink="/location#contact"
          secondaryCtaText="View Our Services"
          secondaryCtaLink="/services"
        />
        <TrustBar />
        <AboutStorySection />
        <MidPageCTA
          heading="Work with Beverly Hills' Premier Design Studio."
          subtext="Serving discerning clients across Los Angeles and nationwide."
          ctaText="Begin Your Project"
          bgColor="charcoal"
        />
        <AIAnswerBlock
          eyebrow="Our Studio"
          heading="About Lisa Merkle Design — Beverly Hills Interior Design Studio"
          what="An editorial-level luxury interior design firm based in Beverly Hills, California. We specialize in residential design, renovation consultation, and full home transformations — serving clients locally and nationwide from our studio at 215 N La Peer Dr."
          who="Discerning homeowners, property investors, developers, and household names who understand that exceptional design is an investment — one that elevates daily living while strengthening long-term property value."
          services="Full House Design · Renovation Consultation · Kitchen & Bathroom · Bedroom & Living Spaces · Art Procurement · Lighting & Flooring · Furniture Customization · Space Planning · Commercial Design"
          benefits="UCLA formal design education, celebrity firm experience, Elle Décor and Architectural Digest publications, personal project leadership by Lisa Merkle, and a trusted network of premium California vendors and craftsmen."
          why="Lisa's UCLA training, celebrity firm experience, and editorial publications distinguish this studio. Classical French, Italian, and Spanish design principles are fused with modern California living — creating interiors that endure."
          highlights={['UCLA Trained', 'Celebrity Firm Alumni', 'Beverly Hills Based', 'Elle Décor Published', 'AD Featured', 'Classical European + California']}
        />
        <ProcessSection />
        <PhilosophySection />
        <ServicesSection limit={12} title="Our Services" subtitle="What We Design" />
        <ServiceAreasSection />
        <TestimonialsSection />
        <MidPageCTA
          heading="Experience the Difference of True Luxury Design."
          subtext="Join our distinguished client roster in Beverly Hills and Los Angeles."
          ctaText="Start Your Design Experience"
          bgColor="warm"
        />
        <FAQSection faqs={ABOUT_FAQS} eyebrow="About Our Studio" heading="About Lisa Merkle Design" />
        <FinalCTA
          title="Experience the Difference of True Luxury Design"
          subtitle="Partner with Beverly Hills' premier interior design studio for your next project."
          ctaText="Start Your Design Experience"
          bgImage="https://lisamerkledesign.com/wp-content/uploads/2022/12/245529933_416062583515497_184245531401349147_n.jpg"
        />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
